import './App.css';
import {Box as MuiBox, styled} from "@mui/material";
import Header from "./components/Header";
import {Outlet} from "react-router";
import Footer from "./components/Footer";

const Box = styled(MuiBox)({
    flexGrow: 1,
    minHeight: '100vh',
    display: "flex",
    flexDirection: 'column',
});

const App = () => {
    return (
        <Box>
            <Header/>
            <Outlet/>
            <Footer/>
        </Box>
    );
};

export default App;
